import { styled } from '@mui/material';

export const StyledDiv = styled('div')`
    display: flex;
    column-gap: 16px;
`;
